import { FormFiller } from 'shared-utils/components/FormFiller/FormFiller';
import styled from 'styled-components';
import { createFormFillerApi } from '../lib/formFillerApi';
import { PageLoadError } from 'design-system/src/components/PageLoadError/PageLoadError';
import { EmbeddedFormInfo } from '../lib/embeddedFormInfo';
import { FormRole } from 'shared-utils/types/formFiller';
import * as Sentry from '@sentry/react';

const EMBEDDED_HEIGHT_PX = 1000;

const IframeContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  min-height: ${EMBEDDED_HEIGHT_PX}px;
  display: flex;
  flex-direction: column;
`;

export const StyledIframe = styled.iframe`
  border: 1px solid var(--grayscale-100);
  border-radius: var(--border-radius-medium);
  flex: 1;
  width: 100%;
  overflow-y: hidden;
`;

const FormFillerContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--grayscale-100);
  max-height: ${EMBEDDED_HEIGHT_PX}px;
`;

export function EmbeddedForm({
  formInfo,
  roleOverride,
  onComplete,
}: {
  formInfo: EmbeddedFormInfo;
  roleOverride?: FormRole;
  onComplete?: () => Promise<void>;
}) {
  if (formInfo.form_source === 'pandadoc') {
    if (onComplete) {
      Sentry.captureMessage('onComplete is not supported for pandadoc forms');
    }
    return (
      <IframeContainer>
        <StyledIframe
          src={formInfo.embedded_document_url}
          // ignore this element in chromatic because the async loading of the contents makes the test flaky
          data-chromatic="ignore"
        />
      </IframeContainer>
    );
  } else if (formInfo.form_source === 'form_filler') {
    return (
      <FormFillerContainer>
        <FormFiller
          api={createFormFillerApi(roleOverride, onComplete)}
          token={formInfo.form_magic_link_token}
          role={roleOverride ?? 'Prescriber'}
          formName={formInfo.form_name}
          allowSignatureUpload={formInfo.allow_signature_upload}
          sidebar={null}
        />
      </FormFillerContainer>
    );
  } else {
    return <PageLoadError />;
  }
}
